<template>
  <div class="container">
    <DataGetter
      :url="`${apiRoute}/${tabRoute}/list/region`"
      :initialData="[selectedRegion]"
      v-slot="{ data }"
      @fetched="setValidCountries"
    >
      <ControlGroup v-if="!country">
        <Dropdown
          label="Country/region"
          :options="[
            {
              label: 'Regions',
              disabled: true,
              options: regions.filter((region) =>
                validCountries.includes(region)
              ),
            },
            {
              label: 'Countries/economies',
              disabled: true,
              options: data.filter(
                (country) =>
                  validCountries.includes(country) && !regions.includes(country)
              ),
            },
          ]"
          v-model="selectedRegion"
          resetOnInvalid
        />
      </ControlGroup>
    </DataGetter>
    <Tabs v-model="selectedTab">
      <Tab title="Renewable electricity" lazy>
        <ElectricityTab
          :apiRoute="apiRoute"
          :selectedRegion="selectedRegion"
          :countryNotes="countryNotes"
        />
      </Tab>
      <Tab title="Transport biofuels" lazy>
        <TransportTab
          v-if="validCountries.includes(selectedRegion)"
          :apiRoute="apiRoute"
          :selectedRegion="selectedRegion"
          :countryNotes="countryNotes"
        />
        <p v-else>No transport biofuels data for {{ selectedRegion }}</p>
      </Tab>
      <Tab title="Renewable heat" lazy>
        <HeatTab
          v-if="validCountries.includes(selectedRegion)"
          :apiRoute="apiRoute"
          :selectedRegion="selectedRegion"
          :countryNotes="countryNotes"
        />
        <p v-else>No renewable heat data for {{ selectedRegion }}</p>
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import {
  DataGetter,
  ControlGroup,
  Dropdown,
  Tab,
  Tabs,
} from "@international-energy-agency/vue-ui";
import ElectricityTab from "./components/ElectricityTab.vue";
import HeatTab from "./components/HeatTab.vue";
import TransportTab from "./components/TransportTab.vue";
const routeByTab = {
  "Renewable electricity": "market",
  "Transport biofuels": "transport",
  "Renewable heat": "heat",
};
export default {
  name: "App",
  components: {
    Tab,
    Tabs,
    ControlGroup,
    Dropdown,
    DataGetter,
    ElectricityTab,
    HeatTab,
    TransportTab,
  },
  props: {
    country: {
      type: String,
      default: null,
    },
    test: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTab: "Renewable electricity",
      selectedRegion: this.country || "World",
      validCountries: ["World"],
      regions: [
        "World",
        "Advanced economies",
        "Emerging markets and developing economies",
        "Africa",
        "Asia (exc. China) and Pacific",
        "Asia Pacific",
        "Central and South America",
        "Eurasia",
        "Europe",
        "European Union",
        "G20",
        "G7",
        "Latin America",
        "Middle East",
        "Middle East and North Africa",
        "Non-OECD Europe and Eurasia",
        "North Africa",
        "North America",
        "South East Asia",
        "Sub-Saharan Africa",
      ],
      countryNotes: {
        Israel:
          "Historical statistical data for Israel is supplied by and under the responsibility of the relevant Israeli authorities. The use of such data by the OECD is without prejudice to the status of the Golan Heights, East Jerusalem and Israeli settlements in the West Bank under the terms of international law.",
        "Latin America":
          "In previous versions of the Renewable Energy Market Report, Mexico was not included in the Latin America aggregate. For the 4 June 2024 update, Mexico has been added to the Latin America aggregate for historical, forecast, indicators and 2030 renewable ambition data.",
      },
    };
  },
  computed: {
    tabRoute() {
      return routeByTab[this.selectedTab];
    },
    apiRoute() {
      const { test } = this;
      return `https://api.${test ? "test." : ""}iea.org/renewables`;
      // return `http://localhost:3000/renewables`;
    },
  },
  methods: {
    setValidCountries(data) {
      this.validCountries = data;
    },
  },
};
</script>

<style>
.m-nav-page__tabs {
  margin-bottom: 40px;
}
/* HACK */
.page-modal-opened .g-mask--modal {
  opacity: 0 !important;
}
/* HACK */
/* rte override */
.f-rte .a-dropdown__options ul:not(:last-child) {
  margin-bottom: 0px;
}
</style>
